import { ModelSagres } from "../../model-sagres";

export class ParticipanteLicitacao extends ModelSagres {
  IdParticipanteLicitacao: number;
  IdLicitacao: number;
  CdCpfCnpjParticipante: string;
  NmParticipante: string;
  TldParticipante: string// = "BR";

  IsVencedor: boolean;
}
